export default __webpack_public_path__ + "static/media/mobile-posts.247cfe47.png";